import styled from '@emotion/styled';
import React from 'react';
import { createPortal } from 'react-dom';

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: all;
    z-index: 2;
`;

const Modal = styled.div`
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    outline: none;
    pointer-events: auto;
`;

export const MediaModalPortal = ({
    isOpen,
    children,
    container,
    onClose,
}: {
    isOpen: boolean;
    children: React.ReactNode;
    container: HTMLElement | null;
    onClose: () => void;
}) => {
    if (!isOpen || !container) return null;

    return createPortal(
        <Overlay
            id="modal-overlay"
            onClick={(e) => {
                if (e.target === document.getElementById('modal-overlay')) {
                    onClose();
                }
            }}
        >
            <Modal>{children}</Modal>
        </Overlay>,
        container
    );
};
